import Timestamp from "components/Timestamp";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { NamedWebhooksIntegration } from "types/generated";

const WebhooksTableTimestampCell = ({
  item: webhook,
  ...cellProps
}: TableSimpleCellProps<NamedWebhooksIntegration>) => {
  return (
    <TableSimpleCell {...cellProps}>
      <Timestamp timestamp={webhook.createdAt} variant="p-body3" />
    </TableSimpleCell>
  );
};

export default WebhooksTableTimestampCell;
